/**
 * Comprovante de PIX/Transferência. O arquivo pode ser anexado na hora (na
 * matrícula ou na troca de cheque/boleto por PIX, indo em base64 no payload) ou
 * depois, pela tela de Controle Pix/Transferência (upload multipart). Anexar
 * nunca é obrigatório.
 */

/** Mesmo limite do ComprovantePagamentoFactory na API. */
export const LIMITE_COMPROVANTE_BYTES = 10 * 1024 * 1024;

export const FORMATOS_COMPROVANTE_ACEITOS = ".pdf,.jpg,.jpeg,.png,.webp";

export const AVISO_COMPROVANTE = "PDF ou imagem (JPG, PNG ou WEBP), até 10 MB.";

export type ComprovantePayload = {
  nomeArquivo: string;
  contentType: string;
  conteudoBase64: string;
};

export const formatarTamanhoArquivo = (bytes?: number) => {
  if (!bytes) return "-";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/**
 * Lê o arquivo escolhido para base64. O FileReader devolve
 * "data:<tipo>;base64,<conteúdo>" — o prefixo é cortado aqui (e a API também
 * aceita com ele, por segurança).
 */
export const lerComprovante = (arquivo: File): Promise<ComprovantePayload> =>
  new Promise((resolve, reject) => {
    const leitor = new FileReader();
    leitor.onerror = () => reject(leitor.error ?? new Error("Falha ao ler o arquivo."));
    leitor.onload = () => {
      const resultado = String(leitor.result ?? "");
      const separador = resultado.indexOf(";base64,");
      resolve({
        nomeArquivo: arquivo.name,
        contentType: arquivo.type,
        conteudoBase64:
          separador >= 0 ? resultado.slice(separador + ";base64,".length) : resultado,
      });
    };
    leitor.readAsDataURL(arquivo);
  });
